import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
moment.locale('pt-BR');

@Pipe({
    name: 'pipeDateSimple'
})
export class PipeDateSimple implements PipeTransform {
    transform(date: string): string {
        return moment(date).format('DD/MM')
    }
}


// WEBPACK FOOTER //
// ./src/app/restricted/pipe/pipeDateSimple.ts